<template>
	<component class="rb-layout" :is="layout">
		<transition name="fade" mode="out-in">
			<router-view/>
		</transition>
	</component>
</template>

<script>
	import DefaultLayout from './layouts/DefaultLayout';
	import {sessionService} from './services/sessionService';

	export default {
		name: 'App',
		metaInfo: {
			titleTemplate: (titleChunk) => {
				return titleChunk ? `${titleChunk} | RWBY Brasil` : 'RWBY Brasil';
			}
		},
		computed: {
			layout() {
				return this.$route.meta.layout || DefaultLayout;
			}
		},
		async created() {
			sessionService.loadSession();
		}
	}
</script>

<style lang="scss">
	.rb-layout {
		min-height: 100vh;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
</style>
